import { render, staticRenderFns } from "./funnel.vue?vue&type=template&id=346964f1&scoped=true&"
import script from "./funnel.vue?vue&type=script&lang=js&"
export * from "./funnel.vue?vue&type=script&lang=js&"
import style0 from "./funnel.vue?vue&type=style&index=0&id=346964f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346964f1",
  null
  
)

export default component.exports